import { buildIdCloudLoginUrl } from '../../auth/session';

export default () => {
  const query = new URLSearchParams(window.location.search);
  const path = query.get('path') || '/admin/profiles/recent';
  document.location.href = buildIdCloudLoginUrl(path);
  return null;
};
